import type { SiteTerminalParametersEntity } from "src/app/features/Site/types/SiteTerminalParametersEntity";
import { extractNestedObject } from "../../../../../core/utils/utilFunctions";
import type { SiteDto } from "../../types/SiteDto";
import type { SiteEntity } from "../../types/SiteEntity";

export const SiteEntityToDto = ({
    dynamicProperties,
    dynamicPropertiesCheckReadOnly: _dynamicPropertiesCheckReadOnly,
    ...rest
}: Readonly<SiteEntity>): SiteDto => {
    const propValues = dynamicProperties?.dynamicPropertyValues?.map((propValue) => {
        const value = propValue.type === "TEXT" ? propValue.value || "" : propValue.value;

        return {
            id: propValue.id,
            key: propValue.key,
            type: propValue.type,
            label: propValue.label,
            pattern: propValue.pattern || "",
            readOnly: propValue.readOnly || false,
            value,
        };
    });

    const terminalParametersDto = extractNestedObject<SiteTerminalParametersEntity>(rest, "terminalParameters");

    const cleanRest = Object.fromEntries(
        Object.entries(rest).filter(([key]) => !key.startsWith("terminalParameters") && !key.startsWith("forceTerminalParameters")),
    );

    return {
        ...cleanRest,
        terminalParameters: terminalParametersDto,
        dynamicProperties: {
            ...dynamicProperties,
            dynamicPropertyValues: propValues,
        },
        virtualSiteGroup: (rest as SiteEntity).virtualSiteGroup,
    };
};
